<template>
<m-pageframe
    title="Test Tock Reservation"
>
<v-container>

    <m-autocomplete-phone-number
        v-model="post_data.phone"
    />

     <v-text-field
        label="Name"
        v-model="post_data.name"
        autocomplete="off"
    />

    <v-text-field
        label="Email"
        v-model="post_data.email"
        autocomplete="off"
    />

    <m-edit-date
        label="Date"
        v-model="post_data.date"
    />

    <v-text-field
        label="Time"
        v-model="post_data.time"
        hint="e.g. 1:30 PM"
    />

    <m-select-timezone
        v-model="post_data.timezone"
    />

    <v-text-field
        label="Party Size"
        v-model="post_data.party_size"
        autocomplete="off"
    />

    <v-text-field
        label="Reservation Number"
        v-model="post_data.reservation_number"
        autocomplete="off"
    />

    <div
        style="text-align: right"
    >
        <v-btn
            color="primary"
            v-on:click="onClickCreateTestReservation"
            :disabled="!valid"
        >
            Create Test Reservation
        </v-btn>
    </div>
       
    {{post_data}}

</v-container>
</m-pageframe>
</template>

<script>
const Time = require('@/js/time.js');
const _ = require('lodash');

export default 
{
    data() {
        return {
            post_data: {
                'email' : 'allie.morgan@example.com',
                'phone' : null,
                'name' : 'Allie Morgan',
                'date' : null,
                'time' : '1:00 PM',
                'timezone' : 'US/Pacific',
                'reservation_number' : Math.floor(Math.random() * 10000),
                'party_size' : 4,
            },
        }
    },

    mounted () {
        let today = new Date();
        let result = today.setDate(today.getDate() + 5);

        this.post_data.date = Time.getISODate(result);
    },

    methods: {
        onClickCreateTestReservation() 
        {
            let params = _.cloneDeep(this.post_data);

            params.phone = this.post_data.phone.value;

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/auto-messages/tock/send-mock-reservation-email',
            
                params,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.snackbar('Test reservation created');
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to create test reservation.');
                },
            );    
        }
    },

    computed: {
        valid() {
            return this.post_data.phone != null;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>